import React, { useEffect, useState } from "react";
import PanelHead from "../../../UI/Panel/PanelHead";
import PanelBody from "../../../UI/Panel/PanelBody";
import { Helper } from "../../../tools/Helper";
import { api_Routes } from "../../../tools/api_Routes";
import { useParams } from "react-router-dom";
import { CircularProgress, LinearProgress } from "@mui/material";
import { FormEditBanner } from "../../../UI/Advertising/banner/edit";

const EditBannerPanel = () => {
  const { id } = useParams();
  const [isLoading, setIsLoading] = useState(true);

  const [data, setData] = useState({
    title: "",
    description: "",
    logo: "",
    customLogo: {
      fontSize: "",
      color: "",
      fontFamily: "",
      logoName: "",
    },
  });

  const getData = async () => {
    try {
      const { result, response } = await Helper.Get({
        url: `${api_Routes.BannersAdvertising.GetOne}${id}`,
      });

      if (response) {
          const bannerData = response?.data[0]
        setData({
          title: bannerData?.title || "",
          description: bannerData?.description || "",
          logo: bannerData?.logo || "",
          customLogo: bannerData?.CustomLogo || "",
        });
      }
    } catch (error) {
      console.error("Error fetching details:", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getData();
  }, []);

  return (
    <div>
      <PanelHead
        title={
          isLoading ? (
            <div className="flex items-center gap-4">
              Edit Main page <CircularProgress size={24} />
            </div>
          ) : (
            <div className="flex items-center justify-between w-full gap-4">
              <div>Edit Main page: {data?.title}</div>
            </div>
          )
        }
      />
      <PanelBody
        content={
          isLoading ? (
            <LinearProgress />
          ) : (
            <FormEditBanner data={data || []} setData={setData} />
          )
        }
      />
    </div>
  );
};

export default React.memo(EditBannerPanel);
